import { withId } from 'react-yandex-metrika';

export enum MetrikaCounter {
    COUNTER_34 = 34,
    COUNTER_191494 = 191494,
    COUNTER_49312303 = 49312303
}

export const metrikaApi = {
    reachGoal: (
        counter: MetrikaCounter,
        goalName: string,
        params: {} = {}
    ): void => {
        const ym = withId(counter);
        ym('reachGoal', goalName, params);
    },

    params: (counter: MetrikaCounter, data: {}): void => {
        const ym = withId(counter);
        ym('params', data);
    }
};
